import './CompteExpert.scss';
import '../../Expert/Profile/donneecv.scss';

import { ArrowForward } from '@mui/icons-material';
import { RemoveRedEye } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Alert, Autocomplete, Button, IconButton, } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import DialogAjouterDiplome from '../../../Components/Dialogs/DialogAjouterDiplome';
import DialogAjouterExperience from '../../../Components/Dialogs/DialogAjouterExperience';
import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import QuillAdvancedTextArea from '../../../Components/shared/QuillAdvancedTextArea';
import { DatePickerComponent, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { API_SERVER_FILES, API_URI_CVTheque, getCVThequeENV } from '../../../config';
import { experienceTotal, foncSkillSet, languesList, niveauxLangue, niveauxSkill } from '../../../data/Interfaces';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
//import { getMessageFrom2DateDirectly } from '../../../hooks/useDateRangeValidator';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
//import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import DocumentUpload from '../../../Utils/fileUpload/DocumentUpload';
import {
    calculateTotalAnneeExperience,
    CompareTwoString, handleRemoveElementFromArrayByIndex, isUrlFromCompleterProfile, SearchIfLangueExsit,
    SearchIfSkillExsit, SearchNewElementEntityCertif, SearchNewElementEntityCV, searchValueLangueByLabel, SpliUrl
} from '../../../Utils/utils';
import { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import CompetenceComponent from './CompetenceComponent';
// TODO : @aida : on doit unifier les CSS : example : divallcomptec
// https://www.bram.us/2021/07/07/automatically-convert-a-javascript-style-object-to-css-custom-properties-with-this-little-helper-tool/
import EditerCertificats from './EditerCertificats';

export const authorizedTypes = [
    typeTraitementEnum.ADMIN_ADD_EXPERT,
    typeTraitementEnum.COLLAB_ESN_ADD_EXPERT,
    typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT,
    typeTraitementEnum.ADMIN_UPDATE_EXPERT,
    typeTraitementEnum.EXPERT_UPDATE,
    typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT,
    typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT,
];

function DonneeCvPartage({ typeTraitement,isDoCandidat }) {
    DonneeCvPartage.propTypes = {
        typeTraitement: PropTypes.any,
        isDoCandidat: PropTypes.any,
    };
    /*
    typeTraitement: {
add: admin adds an expert
updateAdmin: admin update his created expert
readOnly
    }
*/
    const { expertToBeCreated, setExpertToBeCreated } = useCraRdv();
    const { auth, setAuth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const { device,inputSize } = useWindowSize();
    let param = useParams();
    const location = useLocation();
    const {isCandidat } = location.state || {}; // destructure the state
    const isDossierCandidat= (isDoCandidat ?? isCandidat);
    const role = useRole();
    const { setBackdropOpen } = useUtilities();
    const navigate = useNavigate();
    const [proDataId, setProDataId] = useState();
    const [diplomes, setDiplomes] = useState([]);
    const [experiences, setExperiences] = useState([]);
    const [competencesTech, setCompetencesTech] = useState([]);
    const [competencesFonc, setCompetencesFonc] = useState([]);
    const [certificats, setCertificats] = useState([]);
    const [langues, setLangues] = useState([]);
    const [hiddenExtractedPhone, setHiddenExtractedPhone] = useState();
    const [hiddenExtractedEmail, setHiddenExtractedEmail] = useState();
    const [chekDateFin, setChekDateFin] = useState(true);
    const { i18n } = useTranslation();
    //const [, setTechSkillSet] = useState([]);
    // const [searchParams] = useSearchParams();
    // ** ***** ****
    const [messageAlert, setMessageAlert] = useState('');
    const [cvLink, setCvLink] = useState();
    const [diplomeIndex, setDiplomeIndex] = useState();
    const [experienceIndex, setExperienceIndex] = useState();
    const [openAjouterDiplome, setOpenAjouterDiplome] = useState(false);
    const [openAjouterExperience, setOpenAjouterExperience] = useState(false);
    {/*upload Cv variable (//*isUploadingCv is a better name)
    permet de savoir si on a cliqué sur le bouton edit
    pour masquer l'affichage du nom du fichier et afficher le box pour uploader
    un nouveau fichier  exemple : uploadCv==true on est dans la cas où on doit telecharger
    un nouveau cv*/}
    // TODO: what is the initial value
    const [isUploadingCv, setIsUploadingCV] = useState();
    const [resumeFile, setResumeFile] = useState('');
    const [firstDataFromBackend, setFirstDataFromBackend] = useState({});
    const [inputListCertifs, setInputListCertifs] = useState([]);
    const [CheckUpdateValue, setCheckUpdateValue] = useState(true);
    const [langueCV, setLangueCV] = useState('');

    const authorizedUpdateTypes = [
        typeTraitementEnum.ADMIN_UPDATE_EXPERT,
        typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT,
        typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT
    ];

    function isUpdateAuthorizedType(typeTraitement) {
        return authorizedUpdateTypes.includes(typeTraitement);
    }

    // const [isDossierCandidat,setIsDossierCandidat]= useState();
    // const LanguesListAnglais = languesList.map(language => {
    //     return {
    //         value: language.value, // Set the value property to the label value
    //         label: language.value // Set the label property to the label value
    //     };
    // });

    //const [hasUnsavedChanges,setHasUnsavedChanges]=useState(false);
    const target = useRef(null);

    //useEffect(() => {
    //    const handleBeforeUnload = (event) => {
    //        event.preventDefault();
    //        event.returnValue = '';
    //    };

    //    window.addEventListener('beforeunload', handleBeforeUnload);

    //    return () => {
    //        window.removeEventListener('beforeunload', handleBeforeUnload);
    //    };
    //}, []);

    useEffect(() => {
        if (isUrlFromCompleterProfile(location?.pathname))
            setIsUploadingCV(true);
        if (role) {
            searchInfoExpert();
        }
    }, [role]);

    useEffect(() => {
        if (firstDataFromBackend) {
            console.log(firstDataFromBackend);
            initializeDonneeCv(firstDataFromBackend);
        }
    }, [firstDataFromBackend]);

    useEffect(() => {
        if (cvLink) {
            setIsUploadingCV(false);
        }
    }, [cvLink]);

    // useEffect(() => {
    //     if (resumeFile && experiences.length <= 0) {
    //         //* finnaly I've decided to use the value resumeFile?.name if there is no cvLink ... better
    //         // * => and then if found a pb: if we have already a cvLink and we upload another file, it's name wont be displayed until the sauvegade action :)
    //         // * so I update the logic itslef by starting with resumeFile (local Files)
    //         // setCvLink(resumeFile?.name);
    //         submitresumeCVTheque();
    //         setIsUploadingCV(false);
    //         setMessageAlert('');
    //     }
    // }, [resumeFile]);
    useEffect(() => {
        if (resumeFile && experiences.length <= 0) {
            Swal.fire({
                title: 'Confirmer l\'extraction du CV',
                text: 'Voulez-vous extraire les informations du CV et supprimer les données actuelles ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, extraire et remplacer',
                cancelButtonText: 'Non, garder les données existantes',
            }).then((result) => {
                if (result.isConfirmed) {
                    // L'utilisateur veut extraire et supprimer les anciennes données
                    setExperiences([]);
                    setDiplomes([]);
                    setCertificats([]);
                    setCompetencesTech([]);
                    setCompetencesFonc([]);
                    setLangues([]);

                    submitresumeCVTheque(true); // Appel à l'extracteur
                }
            });
            setIsUploadingCV(false);
            setMessageAlert('');
        }
    }, [resumeFile]);

    const searchInfoExpert = async () => {
        if (role == 'expert') {
            setBackdropOpen(true);
            try {
                const response = await axiosPrivate.get('expert/getMyInfos');
                setFirstDataFromBackend(response?.data?.expert);
            } catch (error) {
                console.log(error);
            }
            setBackdropOpen(false);
        }
        //PS: help function => get rowdata from backend using ID
        if (typeTraitement == typeTraitementEnum.READ_ONLY || isUpdateAuthorizedType(typeTraitement)) {
            try {
                const response = await axiosPrivate.get('/users/getExpertById/' + param.ExpertId);
                console.log(response.data);
                setFirstDataFromBackend(response?.data);
                // setdataExpert(response.data);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const initializeDonneeCv = (savedExpert) => {
        //j'ai galéré avec une erreur qui me retourne diplome , experienceList .. (presque toutes les listes) undefined + (not iterable)
        //l'erreur était quand il n'y a pas prodata donc j'ai penser à ajouter cette condition
        if (savedExpert?.proData?._id) {
            setDiplomes(savedExpert?.proData?.etudesEtDiplomes);
            setExperiences(savedExpert?.proData?.experiences);
            setCompetencesTech(savedExpert?.proData?.competencesTechnique);
            setCompetencesFonc(savedExpert?.proData?.competencesFonctionnel);
            const list = savedExpert?.proData?.formationEtCertificats;
            list?.map((element) => {
                element.isEdited = false;
            });
            setCertificats(list);
            setInputListCertifs([]);
            setLangues(savedExpert?.proData?.langues);
            setProDataId(savedExpert?.proData?._id);
            //recupurer l'url du cv
            setCvLink(savedExpert?.persoData?.cv);
            setCheckUpdateValue(true);
        }
    };

    async function submitresumeCVTheque() {
        const formData = new FormData();
        // ! CV Theque
        setBackdropOpen(true);
        try {
            //! was file, but this is a better name
            formData.append('cv', resumeFile);
            let response1, responseData;
            if (getCVThequeENV() == 'remote') {
                response1 = await axiosPrivate.post(
                    '/proxy/uploadResume',
                    formData,
                );
                responseData = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadResume', {
                    method: 'Post',
                    body: formData,
                });
                responseData = await response1.json();
            }
            console.log('submitresumeCVTheque', responseData);
            setHiddenExtractedPhone(responseData.phone);
            setHiddenExtractedEmail(responseData.email);
            //! langue CV
            setLangueCV(responseData?.langueCv);
            //! Experiences
            let experiences2FILL = [...experiences];
            // let valueString;
            responseData?.experiences.map((experience, i) => {
                if (SearchNewElementEntityCV(experiences, experience?.dateDebut, experience?.dateFin) == false) {
                    // if (Array.isArray(experience?.experience)) {
                    //     valueString = experience?.experience.join('<br>');
                    // }
                    if (experience?.isEncours == true)
                        experiences2FILL.push({
                            date: experience?.date,
                            dateDebut: moment(experience?.dateDebut),
                            isEncours: true,
                            dateFin: '',
                            localisation: experience?.localisation,
                            // code avant intitulePoste: experience?.title,
                            intitulePoste: experience?.intitulePoste,
                            entreprise:experience?.entreprise,
                            //code avant entreprise: experience?.entreprise[0] == undefined ? null : experience?.entreprise[0],
                            // description:valueString
                            description: experience?.description,
                            index: i,
                        });
                    else
                        experiences2FILL.push({
                            date: experience?.date,
                            dateDebut: moment(experience?.dateDebut),
                            dateFin: moment(experience?.dateFin),
                            localisation: experience?.localisation,
                            intitulePoste: experience?.intitulePoste,
                            // code avant intitulePoste: experience?.title,intitulePoste
                            // code avant entreprise: experience?.entreprise[0] == undefined ? null : experience?.entreprise[0],
                            entreprise:experience?.entreprise,
                            // description:valueString
                            description: experience?.description,
                            index: i,
                        });

                    if (!experience?.dateFin) {
                        setChekDateFin(false);
                    }
                }
            });
            setExperiences(experiences2FILL);
            //! Diplomes
            let diplomes2Fill = [...diplomes];
            // code avant responseData?.diplomes.map((diplome, i) => {
            responseData?.etudesEtDiplomes.map((diplome, i) => {
                if (SearchNewElementEntityCV(diplomes, diplome?.dateDebut, diplome?.dateFin) == false) {
                    // if (Array.isArray(diplome?.text)) {
                    //     valueString = diplome?.text.join('\n');
                    // }
                    diplomes2Fill.push({
                        dateDebut: diplome?.dateDebut,
                        dateFin: diplome?.dateFin,
                        localisation: diplome?.localisation,
                        formation: diplome?.formation,
                        universite: diplome?.universite ?? diplome?.institution ?? '',
                        index: i,
                    });
                    if(!diplome?.dateFin) {
                        setChekDateFin(false);
                    }
                }
            });
            setDiplomes(diplomes2Fill);
            console.log('Diplomes From Parent', diplomes);
            //! Certifs
            let certifis2FILL = [...certificats];
            console.log('Certifs', responseData?.certifications);
            // code avant responseData?.certifications?.map((certif, i) => {
            responseData?.formationEtCertificats?.map((certif, i) => {
                if (SearchNewElementEntityCertif(certificats, certif?.dateFin) == false) {
                    certifis2FILL.push({
                        dateFin: certif?.dateFin,
                        titre: certif?.titre,
                        isEdited: false,
                        index: i,
                    });
                    if (!certif?.dateFin) {
                        setChekDateFin(false);
                    }
                }
            });
            setCertificats(certifis2FILL);
            //! Technical Skills
            let skillsTech2FIll = [...competencesTech];
            // code avant responseData?.skills_tech.map((skill, i) => {
            responseData?.competencesTechnique.map((skill, i) => {
                if (SearchIfSkillExsit(competencesTech, skill?.titre) == false) {
                    skillsTech2FIll.push({
                        titre: skill?.titre,
                        niveau: skill?.niveau, //only for fisrt steps
                        index: i,
                    });
                }
            });

            setCompetencesTech(skillsTech2FIll);
            //! Fonctionnal Skills
            let skillsFonct2Fill = [...competencesFonc];
            // ! Aida, please reformat your sent data [TODO]
            // code avant responseData?.data?.skills_fonc.map((skill, i) => {
            responseData?.data?.competencesFonctionnel.map((skill, i) => {
                // PS: faut ajouter le test pour l'ajout d'une competence fonctionnelle inexistante
                skillsFonct2Fill.push({
                    titre: skill?.titre,
                    niveau: skill?.niveau, //only for fisrt steps
                    // niveau: niveauxSkill[0].value, //only for fisrt steps code avant
                    index: i,
                });
            });
            setCompetencesFonc(skillsFonct2Fill);
            //! Langues
            let langues2Fill = [...langues];
            console.log('responseData?.langue', responseData?.langue);
            //  code avant responseData?.langue.map((lang, i) => {
            responseData?.langues.map((lang, i) => {
                if (SearchIfLangueExsit(langues, lang) == false) {
                    langues2Fill.push({
                        langue: searchValueLangueByLabel(languesList, lang?.langue.toLowerCase(), 'en'),
                        // niveau: '', //code avant
                        niveau: lang.niveau, //only for fisrt steps
                        index: i,
                    });
                }
            });
            console.log('langues2Fill', langues2Fill);
            setLangues(langues2Fill);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    }

    const navigateToNextStep = (BackendUrl) => {
        if (isUrlFromCompleterProfile(location?.pathname)) {
            if (BackendUrl == '/expert/storeCVData' && auth.completeStep < 3) {
                // * Update the complete step to 3
                setAuth({ ...auth, completeStep: 3 });
            }
            navigate('/expert/completeProfile/step3');
        }
    };
    const getFormDataForCv = () => {
        if (resumeFile) {
            // * on sauvegarde le cv, apres on suavegardre les donnees
            const formData = new FormData();
            formData.append('cv', resumeFile);
            //         formData.append('expertId', expertId);
            return { url: '/docAdministratif/uploadDocumentOnly', payload: formData };
            // return { url: '/docAdministratif/uploadDocumentOnly', payload: new FormData().append('cv', resumeFile) };
        }
        else return { url: '', payload: {} };
    };

    // const getQueryParam = (param) => {
    //     const url = window.location.href; // Get the full URL
    //     const queryString = url.split('?')[1]; // Get everything after the "?"
    //     const params = new URLSearchParams(queryString); // Parse the query string
    //     return params.get(param); // Return the value of the parameter
    // };

    // const isDossierCandidat = getQueryParam('isDossierCandidat');

    function isAuthorizedType(typeTraitement) {
        return authorizedTypes.includes(typeTraitement);
    }

    // useEffect(() => {
    //     console.log('searchParams.get',searchParams.get('isDossierCandidat'));
    //     console.log('searchParams',location);
    //     if(searchParams.get('isDossierCandidat') === 'true' && role=='esn')
    //         setIsDossierCandidat(true);
    //     else if (searchParams.get('isDossierCandidat') === 'false' && role=='esn')
    //         setIsDossierCandidat(false);
    // }, [searchParams,location]);

    const SauvegarderDonneesCv = async (e) => {
        e.preventDefault();
        let BackendUrl = '';
        let response;
        setBackdropOpen(true);
        if (experiences?.length || diplomes?.length || certificats?.length || inputListCertifs?.length || langues?.length || competencesTech?.length || competencesFonc?.length) {
            try {
                const list = certificats.concat(inputListCertifs); //concatener l'ajout avec la liste des certifs
                //setCertificats(list);
                //console.log('expertId expertId',expertId);
                if (proDataId) {
                    BackendUrl = '/expert/updateProData';
                }
                else BackendUrl = '/expert/storeCVData';
                //* resume file se sauvegarede jusqu a la derniere partie dans ADMIN_ADD_EXPERT.
                if (typeTraitement != typeTraitementEnum.ADMIN_ADD_EXPERT && typeTraitement != typeTraitementEnum.COLLAB_ESN_ADD_EXPERT && typeTraitement != typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT) {
                    // BackendUrl = '/expert/storeCVData';
                    if (resumeFile) {
                        // * on sauvegarde le cv, apres on suavegardre les donnees
                        const formData = new FormData();
                        //! was file, but this is a better name
                        formData.append('cv', resumeFile);
                        console.log('### HI SOUAAD, It is me Reda, and here is your Problem: ERR_FILE_NOT_FOUND', resumeFile);
                        //expertId : si l'admin veut ajouter un expert
                        // typeTraitement
                        if ((role == 'admin'||role=='esn') &&
                            (isAuthorizedType(typeTraitement))) {
                            formData.append('expertId', location?.state?.expertId ?? param.ExpertId);
                        }
                        const response1 = await axiosPrivate.post(
                            '/docAdministratif/uploadDocumentOnly',
                            formData,
                        );
                        const responseData1 = await response1?.data;
                        console.log('cvvv souad', { responseData1, remoteCvLink: responseData1?.expert?.persoData?.cv, formData, resumeFile });
                        console.log('cvvv souad _V2_', responseData1, responseData1?.expert?.persoData?.cv, formData, resumeFile);
                        //si on sauvegarde le cv dans le backend nous mettons à jour son nom afin qu'il soit affiché à l'utilisateur le nouveau nom du cv
                        setCvLink(responseData1?.expert?.persoData?.cv);
                    }
                }
                if (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT) {
                    setExpertToBeCreated({
                        ...expertToBeCreated,
                        // AddExpertStep2_ResumeUpload: AddExpertStep2ResumeRequest,
                        AddExpertStep2_ResumeUpload: getFormDataForCv(),
                        AddExpertStep2: {
                            url: '/expert/storeCVData', payload: {
                                //* il va jamais avoir un proDataId : proDataId: proDataId,
                                expertId: location?.state?.expertId || param.ExpertId || 'toBeAdded',
                                experiences: experiences,
                                diplomes: diplomes,
                                certifs: list,
                                langues: langues,
                                skillsTech: competencesTech,
                                skillsFonc: competencesFonc,
                                ...(role === 'esn' && isDossierCandidat==true ? { isDossierCandidat: isDossierCandidat } : {}),
                                //TODO : must be from CVTHEQUE
                                // * old
                                otherInfo:
                                {
                                    email: hiddenExtractedEmail,
                                    phone: hiddenExtractedPhone,
                                    langueCV: langueCV,
                                    totalAnneeExperience: calculateTotalAnneeExperience(experiences)
                                }
                            }
                        },
                    });
                    if(role=='esn')
                        navigate(`/${role}/AddExpertStep3` ,{state:{isCandidat:isDossierCandidat}},{replace:true});
                    else
                        navigate('/admin/AddExpertStep3');

                }
                else if (isUpdateAuthorizedType(typeTraitement))
                    response = await axiosPrivate.post(
                        BackendUrl,
                        {
                            proDataId: proDataId,
                            expertId: location?.state?.expertId || param.ExpertId,
                            experiences: experiences,
                            diplomes: diplomes,
                            certifs: list,
                            langues: langues,
                            skillsTech: competencesTech,
                            skillsFonc: competencesFonc,
                            //TODO : must be from CVTHEQUE
                            // * old
                            otherInfo:
                            {
                                email: hiddenExtractedEmail,
                                phone: hiddenExtractedPhone,
                                langueCV: langueCV,
                                totalAnneeExperience: calculateTotalAnneeExperience(experiences)
                            }
                        }
                    );
                else //* Expert completes his Profile Or updates it
                    response = await axiosPrivate.post(
                        BackendUrl,
                        {
                            proDataId: proDataId,
                            experiences: experiences,
                            diplomes: diplomes,
                            certifs: list,
                            langues: langues,
                            skillsTech: competencesTech,
                            skillsFonc: competencesFonc,
                            isFromAccountCompletion: isUrlFromCompleterProfile(location?.pathname),
                            otherInfo:
                            {
                                email: hiddenExtractedEmail,
                                phone: hiddenExtractedPhone,
                                langueCV: langueCV,
                                totalAnneeExperience: calculateTotalAnneeExperience(experiences)
                            }
                        }
                    );

                const responseData1 = await response?.data;
                console.log('second Step Response', responseData1?.expert);
                navigateToNextStep(BackendUrl);
                setFirstDataFromBackend(responseData1?.expert);
                //faut vider InputCertif après avoir enregistré les deux listes concaténés dans le backend PCQ déjà la liste est ajoutée à Parent Array (certificats)
                setInputListCertifs([]);
                setCheckUpdateValue(true);
                setMessageAlert('');
                setBackdropOpen(false);
                target?.current?.focus();
            } catch (error) {
                console.log(error, error?.response);
                setBackdropOpen(false);
            }
            console.log('viiide');
        }
        else {
            console.log('no videe');
            // * noo need of this logic: if (isUrlFromCompleterProfile(location?.pathname))
            setMessageAlert(i18n.t('Veuillez remplir les champs avant de cliquer sur suivant'));
            setBackdropOpen(false);
        }
    };
    const handleSaveButtonClick = async (e) => {
        const isAllDatesValid = await checkAllFinDates(e);
        console.log('isAllDatesValid',isAllDatesValid);
        if (isAllDatesValid) {
            SauvegarderDonneesCv(e);
        } else {
            console.log('check fin dates');
        }
    };

    const checkAllFinDates = async (e) => {
        e.preventDefault();
        const experiencesWithDateFin = experiences.every((experience) => experience?.dateFin!='');
        console.log('experiencesWithDateFin',experiencesWithDateFin);
        const diplomesWithDateFin = diplomes?.every((diplome) => diplome?.dateFin!='');
        console.log('diplomesWithDateFin',diplomesWithDateFin);
        // const certificatsWithDateFin = certificats?.every((certif) => (certif?.dateFin!='' && certif?.dateFin!=null));
        // const certifAjoute=inputListCertifs?.every((certif) => (certif?.dateFin!='' && certif?.dateFin!=null));
        // console.log('certificats',certificats,'certificatsWithDateFin',certificatsWithDateFin,'certifAjoute',certifAjoute,'inputListCertifs',inputListCertifs);
        const checkDateFin = experiencesWithDateFin && diplomesWithDateFin;// && certificatsWithDateFin && certifAjoute;
        console.log('checkDateFin',checkDateFin);
        setChekDateFin(checkDateFin);
        return checkDateFin;
    };

    const deleteProData = async () => {
        // TODO supprimer un cv ne supprime pas le cv jusqua le sauvegarde : async action
        setBackdropOpen(true);
        try {
            // TODO on peut par la suite supprimer le document dans la prodata .. et on remplace juste le nouveau docuement path dans persoData.cv
            if (proDataId) {
                await axiosPrivate.delete(
                    `/expert/deleteProData/${proDataId}`);
            }
            setCheckUpdateValue(false);
            setResumeFile('');
            setIsUploadingCV(true);
            setBackdropOpen(false);
            setProDataId(null);
            setCvLink(null);
        } catch (error) {
            console.log(error, error?.response);
            setBackdropOpen(false);
        }
    };

    const handleInputChangeLangues = (e, index) => {
        const { name, value } = e.target;
        const list = [...langues];
        if (!CompareTwoString(value, list[index][name]))
            setCheckUpdateValue(false);
        list[index][name] = value;
        setLangues(list);
    };

    const handleInputChangeCertifs = (e, index, champs) => {
        if (champs != 'dateDebut' && champs != 'dateFin') {
            const { name, value } = e.target;
            const list = [...inputListCertifs];
            if (!CompareTwoString(value, list[index][name]))
                setCheckUpdateValue(false);
            list[index][name] = value;
            setInputListCertifs(list);
        }
        else {
            const list = [...inputListCertifs];
            list[index][champs] = e;
            setInputListCertifs(list);
        }
    };

    // * those onChange was used soo many times
    const handleInputChangeCompetencesTech = (e, index) => {
        const { name, value } = e.target;
        const list = [...competencesTech];
        console.log(list[index][name], name, value, index);
        if (!CompareTwoString(value, list[index][name]))
            setCheckUpdateValue(false);
        list[index][name] = value;
        setCompetencesTech(list);
    };

    const handleInputChangeCompetencesFonc = (value, index,name) => {
        const list = [...competencesFonc];
        if (!CompareTwoString(value, list[index][name]))
            setCheckUpdateValue(false);
        list[index][name] = value;
        setCompetencesFonc(list);
    };

    return (
        <form
            style={{
                display: 'flex', gap: '24px',
                flexDirection: 'column',
                alignSelf: 'center',
                width: device == 'desktop' ? '80%' : '100%',
                maxWidth: typeTraitement == typeTraitementEnum.EXPERT_COMPLETE_PROFILE ? '750px' : '1300px',
                minWidth: device == 'desktop' ? '514px' : '200px',
            }}
        >
            <div className='donneescv'>
                <h4 className='titlesociete'>{i18n.t('Données CV')}</h4>
            </div>

            {messageAlert && (<div><Alert severity="error">{messageAlert}</Alert></div>)}
            {!chekDateFin && (<div><Alert severity="error">{i18n.t('Veuillez compléter les dates manquantes dans vos données CV')}</Alert></div>)}

            <div className='divcvicon'>
                <div className='divcvtitle'>
                    <div className='moncv'>
                        <div className='imgbgcv'>
                            <img
                                className='imgcvstyle'
                                src="/img_card/cvicon.png"
                            />
                        </div>
                        <h5 className='moncvtxt'>{i18n.t('Mon CV')}</h5>
                    </div>
                    {
                        ((role == 'expert' && !isUrlFromCompleterProfile(location?.pathname)) ||
                            ((role == 'admin' || role=='esn') && (isAuthorizedType(typeTraitement))
                            ))
                        &&
                        <div className='editcvicon'>
                            <IconButton
                                onClick={() => {
                                    setCheckUpdateValue(false);
                                    setIsUploadingCV(true);
                                }}
                            >
                                <ModeEditOutlinedIcon />
                            </IconButton>
                        </div>
                    }
                </div>
                {/*l'expert + l'admin dans le cas d'ajout d'un expert peuvent faire les fonctionnalites suivantes (modif d'un cv , ajout d'un cv)*/}
                {isUploadingCv == false &&
                    <div className='cvuploadedStyle'>
                        <div className='cvinfos'>
                            {/*à changer il faut travailler avec la fonction SpliUrl dans util (by me aida) */}
                            {/* // TODO : we must have the latest elemnt  = fileName */}
                            {/* <p style={cvnamestyle}>{cvLink? SpliUrl(cvLink):resumeFile?.name}</p> */}
                            {(cvLink || resumeFile?.name) &&
                                <p className='cvnamestyle'>{resumeFile?.name ? resumeFile?.name : SpliUrl(cvLink)}</p>
                            }
                        </div>

                        {(role == 'expert' ||
                            (role == 'admin' &&
                            {/* (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT ||
                                    typeTraitement == typeTraitementEnum.ADMIN_UPDATE_EXPERT) */}
                            ) || (role=='esn')
                        ) && (cvLink || resumeFile?.name) &&
                            <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
                                <IconButton
                                    variant='contained'
                                    component='label'
                                    className='uploadicon'
                                    disabled={!cvLink}
                                >
                                    <a
                                        href={API_SERVER_FILES + encodeURIComponent(cvLink)}
                                        target="_blank"
                                        rel="noreferrer"
                                        download
                                    >
                                        <RemoveRedEye />
                                    </a>
                                </IconButton>
                                {typeTraitement !== typeTraitementEnum.READ_ONLY &&
                                    <IconButton
                                        variant='contained'
                                        component='label'
                                        onClick={() => {
                                            deleteProData();
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>}
                            </div>
                        }
                    </div>
                }

                {(role == 'expert' || ((role == 'admin'||role=='esn') &&
                    (isAuthorizedType(typeTraitement))))
                    && isUploadingCv == true &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px',alignSelf:'stretch' }}>
                        <DocumentUpload
                            required
                            setFile={setResumeFile}
                            document={resumeFile}
                            setCheckUpdateValue={setCheckUpdateValue}
                        />
                        {isUrlFromCompleterProfile(location?.pathname) == false &&
                            <div>
                                <Button
                                    variant="outlined"
                                    //style={{ width: '136px', border: '1px solid #214DCE', borderRadius: '8px' }}
                                    //startIcon={<ArrowBack />}
                                    style={{ ...buttonStyles(), ...{ width: '136px' } }}
                                    onClick={() => {
                                        if ((cvLink || resumeFile?.name))
                                            setIsUploadingCV(false);
                                    }
                                    }
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                            </div>
                        }
                    </div>
                }
            </div>

            {/*<PreventUnload />
            <AlertDialog isBlocking={hasUnsavedChanges} />*/}
            {/*<Prompt when={hasUnsavedChanges} message={ => 'are you sure?' }  />*/}
            {/*<Prompt when={hasUnsavedChanges} message="You have unsaved changes. Are you sure you want to leave?" />*/}
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ backgroundColor: '#F5F9FC', padding: '5px' }}>
                        <h4 className='titlesociete'>{i18n.t('Etudes et Diplômes')}</h4>
                    </Accordion.Header>
                    <Accordion.Body >
                        <div className='RangDplome'>
                            {diplomes?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {/*{ordrePlusRecenteAuAncien(diplomes)?.map((element, i) => (*/}
                            {diplomes?.map((element, i) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignSelf: 'stretch'
                                    }}
                                    key={i}
                                >
                                    <div
                                        className='experiencesStyle'
                                        key={i}
                                    >
                                        {element?.date ?
                                            <p className='ecole'>{element?.date}</p>
                                            :
                                            <p className='experdet'>{formatDateJJMMYYYY(element?.dateFin)}  {element?.localisation} </p>
                                        }
                                        <div style={{ width: '100%' }}>
                                            {/*<pre>*/}
                                            {/*<code> */}
                                            {/*<h5 style={specialityname}>*/}
                                            {element?.formation}
                                            {/*</h5>*/}
                                            {/*</code>*/}
                                            {/*</pre>*/}
                                        </div>

                                        <p className='ecolename'>{element?.universite ?? element?.institution}</p>
                                    </div>
                                    {(role != 'client' &&
                                        isAuthorizedType(typeTraitement)) &&
                                        <div className='editIcon'>
                                            <div className='editIcon1'>
                                                <IconButton
                                                    onClick={() => {
                                                        setCheckUpdateValue(false);
                                                        setDiplomeIndex(i);
                                                        setOpenAjouterDiplome(true);
                                                    }}
                                                >
                                                    <ModeEditOutlinedIcon />
                                                </IconButton>
                                            </div>
                                            <div style={{ alignSelf: 'center' }}>
                                                <IconButton
                                                    onClick={() => {
                                                        setCheckUpdateValue(false);
                                                        setDiplomes(handleRemoveElementFromArrayByIndex(diplomes, i));
                                                    }}
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </div>
                                        </div>
                                    }
                                </div>
                            ))
                            }
                            {(role !='client' &&
                                isAuthorizedType(typeTraitement)) &&
                                <Button
                                    onClick={() => {
                                        setCheckUpdateValue(false);
                                        setOpenAjouterDiplome(true);
                                        //setHasUnsavedChanges(true);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter un diplôme')}</Button>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion >
                <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ backgroundColor: '#F5F9FC', padding: '5px' }}>
                        <h4 className='titlesociete'>{i18n.t('Expériences')}</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='RangDplome'>
                            {experiences?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {
                                //avant il y avait ca ms caused prblm in plateforme -->ordrePlusRecenteAuAncien(experiences).map((experience, i) => (
                                experiences.map((experience, i) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignSelf: 'stretch'
                                        }}
                                        key={i}
                                    >
                                        <div className='expdetail'>
                                            {experience?.date ?
                                                <p className='experdet'> {experience?.date} </p>
                                                :
                                                <p className='experdet'> {formatDateJJMMYYYY(experience?.dateDebut)} - {experience?.isEncours ? 'Aujourd\'hui' : formatDateJJMMYYYY(experience?.dateFin)}   {experience?.localisation}</p>
                                            }
                                            {/*<div
                                                    style={{display:'flex',
                                                                flexDirection: 'row',
                                                                gap: '8px',
                                                                alignItems: 'baseline',
                                                        }}>*/}
                                            <h5 className='exptitletxt'>{experience?.intitulePoste}</h5>
                                            <p className='societename'>{experience?.entreprise}</p>
                                            {experience?.description &&
                                                <QuillAdvancedTextArea
                                                    value={experience?.description}
                                                    readOnly={true}
                                                    className='experiencedetails'
                                                    theme='bubble'
                                                />
                                            }
                                        </div>
                                        {(role == 'expert' || ((role == 'admin' || role=='esn') &&
                                            isAuthorizedType(typeTraitement))) &&
                                            <div className='editIcon'>
                                                <div className='editIcon1'>
                                                    <IconButton
                                                        onClick={() => {
                                                            setCheckUpdateValue(false);
                                                            setExperienceIndex(i);
                                                            setOpenAjouterExperience(true);
                                                        }}
                                                    >
                                                        <ModeEditOutlinedIcon />
                                                    </IconButton>
                                                </div>
                                                <div style={{ alignSelf: 'center' }}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setCheckUpdateValue(false);
                                                            setExperiences(handleRemoveElementFromArrayByIndex(experiences, i));
                                                        }}
                                                    >
                                                        <DeleteForeverIcon />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))
                            }
                            {(role == 'expert' || ((role == 'admin' || role=='esn') &&
                                isAuthorizedType(typeTraitement))) &&
                                <Button
                                    onClick={() => {
                                        setCheckUpdateValue(false);
                                        setOpenAjouterExperience(true);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter une expérience')}</Button>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion >
                <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ backgroundColor: '#F5F9FC', padding: '5px' }}>
                        <h4 className='titlesociete'>{i18n.t('Compétences')}</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='divallcomptec'>
                            <div className='comptechnic'>
                                <h6 className='txtechstyle'>{i18n.t('Technique ?')}</h6>
                                <p className='techadvstyle'>{i18n.t('Valorisez votre profil auprès des clients et augmentez la visibilité de votre CV!')}</p>
                            </div>
                            {competencesTech?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {
                                competencesTech?.map((element, i) => (
                                    <div
                                        style={{
                                            display: device == 'desktop' ? 'flex' : 'grid',
                                            gridTemplateColumns: 'repeat(2,1fr)',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignSelf: 'stretch',
                                            gap: '16px',
                                        }}
                                        key={i}
                                    >
                                        <div style={{ width: device == 'desktop' ? '50%' : '100%' }}>
                                            <p className='row1skillnametxt'>{i18n.t('Compétence')}</p>
                                            <CompetenceComponent
                                                skill={element}
                                                index={i}
                                                skillsTech={competencesTech}
                                                setSkillsTech={setCompetencesTech}
                                                disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                                            />
                                        </div>
                                        <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                            <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                            <SelectComponent
                                                name='niveau'
                                                disabled={((!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) || typeTraitement == typeTraitementEnum.READ_ONLY) ?
                                                    true : false}
                                                val={element?.niveau}
                                                setVal={e => {
                                                    handleInputChangeCompetencesTech(e, i);
                                                }}
                                                listVal={niveauxSkill}
                                            />
                                        </div>
                                        <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                            <p className='row1skillnametxt2'>{i18n.t('Expérience totale')}</p>
                                            <SelectComponent
                                                disabled={(!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                                name='experienceTotal'
                                                val={element?.experienceTotal}
                                                setVal={e => handleInputChangeCompetencesTech(e, i)}
                                                listVal={experienceTotal}
                                            />
                                        </div>
                                        {(role == 'expert' || ((role == 'admin' || role=='esn') && isAuthorizedType(typeTraitement))) &&
                                            <div style={{ paddingTop: '26px', alignSelf: 'center' }}>
                                                <IconButton
                                                    onClick={() => {
                                                        setCheckUpdateValue(false);
                                                        setCompetencesTech(handleRemoveElementFromArrayByIndex(competencesTech, i));
                                                    }}
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </div>
                                        }
                                    </div>
                                ))
                            }
                            {(role == 'expert' || ((role == 'admin' || role=='esn') && isAuthorizedType(typeTraitement))) &&
                                <Button
                                    onClick={() => {
                                        setCheckUpdateValue(false);
                                        setCompetencesTech([...competencesTech,
                                            { titre: '', niveau: '', experienceTotal: '' }]);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter une compétence')}</Button>
                            }

                        </div>
                        <div className='divallcompfoncStyle'>
                            <div className='comptechnic'>
                                <h6 className='txtechstyle'>{i18n.t('Fonctionnelles ?')}</h6>
                                <b className='techadvstyle'>{i18n.t('Valorisez votre profil auprès des clients et augmentez la visibilité de votre CV!')}</b>
                            </div>
                            {competencesFonc?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {
                                competencesFonc?.map((element, i) => (
                                    <div
                                        style={{
                                            display: device == 'desktop' ? 'flex' : 'grid',
                                            gridTemplateColumns: 'repeat(2,1fr)',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignSelf: 'stretch',
                                            gap: '16px',
                                        }}
                                        key={i}
                                    >
                                        <div style={{ width: device == 'desktop' ? '50%' : '100%' }}>
                                            <b className='row1skillnametxt'>{i18n.t('Compétence')}</b>
                                            <Autocomplete
                                                //type="text"
                                                size={inputSize}
                                                value={element?.titre}
                                                freeSolo
                                                options={foncSkillSet.map((option) => option?.title)}
                                                name='titre'
                                                onInputChange={(e,value) => {
                                                    handleInputChangeCompetencesFonc(value,i,'titre');
                                                }}
                                                disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                                                sx={{
                                                    '& > :not(style)': { borderRadius: '8px' },
                                                }}
                                                style={{ width: '100%', borderRadius: '8px' }}
                                                renderInput={(params) =>
                                                    <TextFieldComponent
                                                        {...params}
                                                        sx={{
                                                            '& > :not(style)': { borderRadius: '8px' },
                                                        }}

                                                    />}
                                            />
                                        </div>
                                        <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                            <b className='row1skillnametxt2'>{i18n.t('Niveau')}</b>
                                            <SelectComponent
                                                name='niveau'
                                                disabled={(!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                                setVal={e => {
                                                    const { name, value } = e.target;
                                                    const list = [...competencesFonc];
                                                    list[i][name] = value;
                                                    setCompetencesFonc(list);
                                                }}
                                                val={element?.niveau}
                                                listVal={niveauxSkill}
                                            />
                                        </div>
                                        <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                            <b className='row1skillnametxt2'>{i18n.t('Expérience totale')}</b>
                                            <SelectComponent
                                                name='experienceTotal'
                                                disabled={(!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                                setVal={e => {
                                                    const { name, value } = e.target;
                                                    const list = [...competencesFonc];
                                                    list[i][name] = value;
                                                    setCompetencesFonc(list);
                                                }}
                                                val={element?.experienceTotal}
                                                listVal={experienceTotal}
                                            />
                                        </div>
                                        {/*<div style={{ width: '24%' }}>
                                            <b className='row1skillnametxt2'>Plus récente expérience</b>
                                            <SelectComponent
                                                disabled={(!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                                setVal={e => handleInputChangeCompetencesFonc(e, i)}
                                                val={element?.experiencePlusRecente}
                                                name='experiencePlusRecente'
                                                listVal={plusRecenteExperience}
                                            />
                                        </div>*/}
                                        {(role == 'expert' || ((role == 'admin' || role=='esn') && isAuthorizedType(typeTraitement))) &&
                                            <div style={{ paddingTop: '26px', alignSelf: 'center' }}>
                                                <IconButton
                                                    onClick={() => {
                                                        setCheckUpdateValue(false);
                                                        setCompetencesFonc(handleRemoveElementFromArrayByIndex(competencesFonc, i));
                                                    }}
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </div>
                                        }
                                    </div>
                                ))
                            }
                            {(role == 'expert' || ((role == 'admin' || role=='esn') && isAuthorizedType(typeTraitement))) &&
                                <Button
                                    onClick={() => {
                                        setCheckUpdateValue(false);
                                        setCompetencesFonc([...competencesFonc, { titre: '', niveau: '', experienceTotal: '' }]);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter une compétence')}</Button>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ backgroundColor: '#F5F9FC', padding: '5px' }}>
                        <h4 className='titlesociete'>{i18n.t('Formation et Certificats')}</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='RangDplome'>
                            {certificats?.length < 1 && inputListCertifs?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {certificats?.map((element, i) => (
                                //is edited in certif list
                                <EditerCertificats
                                    key={i}
                                    index={i}
                                    setCheckUpdateValue={setCheckUpdateValue}
                                    certificats={certificats}
                                    chekDateFin={chekDateFin}
                                    setChekDateFin={setChekDateFin}
                                    setCertificats={setCertificats}
                                    typeTraitement={typeTraitement}
                                />
                            ))
                            }
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignSelf: 'stretch' }}>
                                {/* //* les certificat ajoutee maintenant */}
                                {/* avant ms it caused sort prblm ordrePlusRecenteAuAncien(inputListCertifs).map((element, i) => {*/}
                                {inputListCertifs.map((element, i) => {
                                    //const error = getMessageFrom2DateDirectly(element?.dateDebut, element?.dateFin);
                                    return (
                                        <div
                                            key={i}
                                            className='techcompetencestyle'
                                        >
                                            <div style={{ width: '50%' }}>
                                                <p className='row1skillnametxt2'>{i18n.t('Formation ou certificat')}</p>
                                                <TextFieldComponent
                                                    style={{ width: '100%', background: 'white' }}
                                                    value={element?.titre}
                                                    name='titre'
                                                    // name="certificats" : WHY THIS BLOCKS THE ONCHANGE ??? : because we are using the explicit tag name 'titre', not dynamic :(
                                                    onChange={e => handleInputChangeCertifs(e, i)}
                                                    type='text'
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <p className='row1skillnametxt2'>{i18n.t('Date fin')}</p>
                                                <DatePickerComponent
                                                    date={element?.dateFin}
                                                    disabled={(!element?.titre || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                                    setDate={(newValue) => {
                                                        handleInputChangeCertifs(newValue, i, 'dateFin');
                                                    }}
                                                    width={'100%'}
                                                    name='dateFin'
                                                    views={['year', 'month']}
                                                />
                                            </div>
                                            {(role !='client' && isAuthorizedType(typeTraitement)) &&
                                                <div style={{ paddingTop: '26px', alignSelf: 'center' }}>
                                                    <IconButton
                                                        onClick={
                                                            () => {
                                                                setCheckUpdateValue(false);
                                                                setInputListCertifs(handleRemoveElementFromArrayByIndex(inputListCertifs, i));
                                                            }}
                                                    >
                                                        <DeleteForeverIcon />
                                                    </IconButton>
                                                </div>
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                            {(role !='client' && isAuthorizedType(typeTraitement)) &&
                                <Button
                                    onClick={() => {
                                        setInputListCertifs([...inputListCertifs, { titre: '', dateDebut: '', dateFin: '' }]);
                                        setCheckUpdateValue(false);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter une qualification')}</Button>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ backgroundColor: '#F5F9FC', padding: '5px' }}>
                        <h4 className='titlesociete'>{i18n.t('Langues')}</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='divallcomptec'>
                            {langues?.length < 1 &&
                                <p>{i18n.t('Aucune donnée ajoutée')}</p>
                            }
                            {Array.isArray(langues) && langues?.map((element, i) => (
                                <div
                                    className='techcompetencestyle'
                                    key={i}
                                >

                                    <div style={{ width: '48%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Langue')}</p>
                                        <SelectComponent
                                            setVal={e => handleInputChangeLangues(e, i)}
                                            val={element?.langue}
                                            disabled={typeTraitement == typeTraitementEnum.READ_ONLY ? true : false}
                                            name='langue'
                                            listVal={languesList}
                                            // listVal={langueCV == 'fr' ? languesList : LanguesListAnglais} //c'etait avant la traduction
                                        />
                                    </div>
                                    <div style={{ width: '48%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                        <SelectComponent
                                            setVal={e => handleInputChangeLangues(e, i)}
                                            disabled={(!element?.langue || typeTraitement == typeTraitementEnum.READ_ONLY) ? true : false}
                                            val={element?.niveau}
                                            name='niveau'
                                            listVal={niveauxLangue}
                                        />
                                    </div>
                                    {(role == 'expert' || ((role == 'admin'||role=='esn') && isAuthorizedType(typeTraitement))) &&
                                        <div style={{ paddingTop: '26px', alignSelf: 'center' }}>
                                            <IconButton
                                                onClick={() => {
                                                    setCheckUpdateValue(false);
                                                    setLangues(handleRemoveElementFromArrayByIndex(langues, i));
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                            ))
                            }
                            {(role == 'expert' || ((role == 'admin'||role=='esn') && isAuthorizedType(typeTraitement))) &&
                                <Button
                                    onClick={() => {
                                        setCheckUpdateValue(false);
                                        setLangues([...langues, { langue: '', niveau: '' }]);
                                    }}
                                    style={{ ...buttonStyles() }}
                                    startIcon={<AddIcon />}
                                >{i18n.t('Ajouter une langue')}</Button>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <div
                style={{
                    display: 'flex',
                    flexDirection: device == 'desktop' ? 'row' : 'column',
                    gap: device == 'desktop' ? '0px' : '16px',
                    justifyContent: 'space-between',
                    alignSelf: 'stretch',
                    marginTop: '40px',
                }}
            >
                {((role == 'expert' && !isUrlFromCompleterProfile(location?.pathname)) || isUpdateAuthorizedType(typeTraitement)) &&
                    <>
                        <Button
                            variant="text"
                            style={{ ...buttonStyles() }}
                            onClick={() => { initializeDonneeCv(firstDataFromBackend); }}
                        >
                            {i18n.t('Annuler')}
                        </Button>
                        <Button
                            // disabled={!isValid || CheckUpdateValue}
                            // ! it gives bad impression about did we save or not
                            disabled={CheckUpdateValue}
                            variant="contained"
                            type="submit"
                            style={{ ...buttonStylesBlue(CheckUpdateValue) }}
                            //style={{...buttonStyles(),...{}}}
                            onClick={handleSaveButtonClick}
                            startIcon={<SaveOutlinedIcon />}
                        >
                            {i18n.t('Sauvegarder')}
                        </Button>
                    </>
                }
                {(role == 'expert' && isUrlFromCompleterProfile(location?.pathname)) &&
                    <>
                        <Button
                            variant="outlined"
                            style={{ ...buttonStyles() }}
                            onClick={() => navigate('/expert')}
                        >
                            {i18n.t('Remplir plus tard')}
                        </Button>
                        <Button
                            // disabled={!isValid}
                            variant="contained"
                            type="submit"
                            ref={target}
                            style={{ ...buttonStylesBlue() }}
                            onClick={SauvegarderDonneesCv}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('Valider')}
                        </Button>
                    </>
                }
                {((role == 'admin'||role=='esn') && (typeTraitement == typeTraitementEnum.ADMIN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_EXPERT || typeTraitement == typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT)) &&
                    <>
                        <Button
                            variant="contained"
                            type="submit"
                            style={{ ...buttonStylesBlue() }}
                            onClick={SauvegarderDonneesCv}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('Suivant')}
                        </Button>
                    </>
                }
            </div>

            {openAjouterDiplome &&
                <DialogAjouterDiplome
                    handleClose={() => {
                        setOpenAjouterDiplome(false);
                    }}
                    open={openAjouterDiplome}
                    setDiplomes={setDiplomes}
                    diplomes={diplomes}
                    diplomeIndex={diplomeIndex}
                    setDiplomeIndex={setDiplomeIndex}
                />}

            {openAjouterExperience &&
                <DialogAjouterExperience
                    handleClose={() => {
                        setOpenAjouterExperience(false);
                    }}
                    setExperiences={setExperiences}
                    experiences={experiences}
                    experienceIndex={experienceIndex}
                    setExperienceIndex={setExperienceIndex}
                    open={openAjouterExperience}
                />}
        </form>
    );
}
export default DonneeCvPartage;